export const AMBIGUOUS_EXCEPTION_TYPE = "Ambiguous Exception Reprocess";
export const NOTIFICATION_TIMEOUT_IN_SEC = 10000;
export const API_SLEEP_TIME_IN_MSEC = 5000;
export const LAZY_LOAD_BATCH_DETAILS_KEY = "view";
export const MAXIMUM_REASON_LENGTH_SUPPORTED = 1000;
export const DATE_FORMAT_MM_YYYY = "MM-YYYY";
export const DATE_FORMAT_MMM_YY = "MMM-YY";
